<template>
  <div>
    <search
      :title="`${$t('modal.salesperson')}`"
      :items="salers"
      idProperty="EmployeeId"
      nameProperty="EmployeeName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />
    <employee-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import employeeSelect from "@/components/selects/EmployeeSelects";

export default {
  data() {
    return {
      trigger: false,
      salers: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Saler) {
        this.salers = value.Saler;
      }
    },
  },
  components: {
    search,
    employeeSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.salers];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.salers = items;
      this.set();
    },
    remove(index) {
      if (!this.salers[index]) return;
      this.salers.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.salers);
    },
  },
};
</script>
